import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6">
      <ol className="flex items-center gap-2 text-sm text-foreground-500 py-4 flex-wrap">
        <li>
          <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">
            <i className="ri-home-4-line"></i>
          </Link>
        </li>
        {items.map((item, idx) => (
          <li key={idx} className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>
            {item.path ? (
              <Link to={item.path} className="hover:text-primary-500 transition-colors cursor-pointer">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}